import { SERIES_CHART_CONFIGS } from "../constants";

const getCountDistribution = (plotItem, node, driverVariables) => {
  const driverVariable = driverVariables.find(
    item => item.column_name === node.data.label
  );
  const name = "count-distribution";
  const fill = "#8884d8";
  const dataKey = "Count";
  const data = plotItem.plot.bins.map(item => ({
    name:
      driverVariable?.values.find(val => val.id === item.id)?.name || "Blank",
    [dataKey]: item.count,
  }));
  return [{ name, data, fill, dataKey }];
};

const getCountDistributionNumeric = plotItem => {
  const name = "count-distribution-numeric";
  const fill = "#8884d8";
  const dataKey = "Count";
  const data = plotItem.plot.bins.map(item => ({
    name:
      item.from === item.to
        ? item.from
        : `[${item.from.toLocaleString()}-${item.to.toLocaleString()})`,
    [dataKey]: item.count,
  }));
  return [{ name, data, fill, dataKey }];
};

const getDistributionAgainstTarget = (
  { plot: { bins, first_variable_values_ids, second_variable_values_ids } },
  node,
  driverVariables
) => {
  const driverVariable = driverVariables.find(
    item => item.column_name === node.data.label
  );
  const data = second_variable_values_ids?.reduce(
    (acc, item, i) => {
      const name =
        driverVariable.values.find(val => val.id === item)?.name || "Blank";
      if (bins.length > 1) {
        return {
          negative: [...acc.negative, { name, Negative: bins[0][i] }],
          positive: [...acc.positive, { name, Positive: bins[1][i] }],
        };
      } else if (first_variable_values_ids[0] === 1) {
        return {
          positive: [...acc.positive, { name, Positive: bins[0][i] }],
          negative: [...acc.negative, { name, Negative: 0 }],
        };
      }

      return {
        positive: [...acc.positive, { name, Positive: 0 }],
        negative: [...acc.negative, { name, Negative: bins[0][i] }],
      };
    },
    { positive: [], negative: [] }
  );
  return [
    { ...SERIES_CHART_CONFIGS[0], data: data.negative },
    { ...SERIES_CHART_CONFIGS[1], data: data.positive },
  ];
};

const getDistributionAgainstTargetNumeric = ({
  plot: { columns, categorical_variable_values_ids },
}) =>
  columns?.map(({ bins, categorical_value_id }) => {
    const { name, fill, dataKey } =
      SERIES_CHART_CONFIGS[
        categorical_variable_values_ids[categorical_value_id]
      ];
    const data = bins.map(item => ({
      name:
        item.from === item.to
          ? item.from
          : `[${item.from.toLocaleString()}-${item.to.toLocaleString()})`,
      [dataKey]: item.count,
    }));
    return { name, data, fill, dataKey };
  });

export {
  getCountDistribution,
  getCountDistributionNumeric,
  getDistributionAgainstTarget,
  getDistributionAgainstTargetNumeric,
};
